import { apiClient } from "@/services/apiClient";

export interface IssuerCompanySummary {
  id: string;
  name: string;
  legalName: string | null;
  rut: string;
}

export interface IssuerBrandSummary {
  id: string;
  name: string;
}

export interface PlatformConfigResponse {
  subscriptionIssuerCompanyId: string | null;
  subscriptionIssuerCompany: IssuerCompanySummary | null;
  /** The marca Fiscalo's own subscription CFEs are issued under. */
  subscriptionIssuerBrandId: string | null;
  subscriptionIssuerBrand: IssuerBrandSummary | null;
  /** The issuer's active marcas, served alongside so the picker needs no
   *  second call (and cannot offer another tenant's brand). */
  issuerBrands: IssuerBrandSummary[];
}

export function getPlatformConfig(): Promise<PlatformConfigResponse> {
  return apiClient
    .get<PlatformConfigResponse>("/platform/config")
    .then((res) => res.data);
}

export function listTenantCompanies(): Promise<IssuerCompanySummary[]> {
  return apiClient
    .get<IssuerCompanySummary[]>("/platform/config/tenant-companies")
    .then((res) => res.data);
}

export function setSubscriptionIssuer(
  companyId: string | null,
): Promise<{ subscriptionIssuerCompanyId: string | null }> {
  return apiClient
    .put<{ subscriptionIssuerCompanyId: string | null }>(
      "/platform/config/subscription-issuer",
      { companyId },
    )
    .then((res) => res.data);
}

export function setSubscriptionIssuerBrand(
  brandId: string | null,
): Promise<{ subscriptionIssuerBrandId: string | null }> {
  return apiClient
    .put<{ subscriptionIssuerBrandId: string | null }>(
      "/platform/config/subscription-issuer-brand",
      { brandId },
    )
    .then((res) => res.data);
}
